import type { Channel } from "@daangn/idl/rocketchat/api/model";
import { type NormalizedSchema, normalize } from "@data-client/normalizr";
import type { ChatMessage } from "../chatMessage/chatMessage.entity";
import type { ChannelID, NormalizedResult } from "../types";
import type { User } from "../user/user.entity";
import { Channel as ChannelEntity } from "./channel.entity";

type ChannelNormalizeParams = {
  channel: Channel;
};

export const getNormalizedChannel = ({ channel }: ChannelNormalizeParams) => {
  const normalizedChannel = normalize<
    typeof ChannelEntity,
    {
      Channel: NormalizedResult<ChannelEntity>;
      User: NormalizedResult<User>;
    }
  >(ChannelEntity, channel);

  return normalizedChannel;
};

type GetNormalizedChannelListParams = {
  channels: Channel[];
};
export const getNormalizedChannelList = ({
  channels,
}: GetNormalizedChannelListParams) => {
  const normalizedChannelList = normalize<
    (typeof ChannelEntity)[],
    {
      Channel: NormalizedResult<ChannelEntity>;
      User: NormalizedResult<User>;
      ChatMessage: NormalizedResult<ChatMessage>;
    }
  >([ChannelEntity], channels);

  return normalizedChannelList;
};

type GetNormalizedChannelByIdParams = {
  channelId: ChannelID;
  normalizedData: NormalizedSchema<
    {
      Channel: NormalizedResult<ChannelEntity>;
    },
    string | undefined
  >;
};
export const getNormalizedChannelById = ({
  channelId,
  normalizedData,
}: GetNormalizedChannelByIdParams): ChannelEntity | undefined => {
  return normalizedData.entities.Channel[channelId];
};
